export var VehicleModelState;
(function (VehicleModelState) {
    VehicleModelState["USABLE"] = "USABLE";
    VehicleModelState["UNUSABLE"] = "UNUSABLE";
})(VehicleModelState || (VehicleModelState = {}));
